<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import OfficeHours from "./components/OfficeHours.vue";

export default {
    components: { Layout, PageHeader, OfficeHours },
    props: {
        userOfficeHoursDetails: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data() {
        return {
            title: "Office Hours Management",
            items: [
                {
                    text: "Apps",
                    href: "/",
                },
                {
                    text: "Office Hours Management",
                    active: true,
                },
            ],
        };
    },
    computed: {
        // Example Admin, Enterprise Partner, Tax Company, Tax Payer
        browserTitle() {
            return (
                this.$page.props.auth.user.user_type_text +
                " - Office Hours Management"
            );
        },
    },
};
</script>

<template>
    <Layout>
        <Head :title="browserTitle" />
        <PageHeader :title="title" :items="items" />
        <OfficeHours :userOfficeHoursDetails="userOfficeHoursDetails" />
    </Layout>
</template>
